import { httpRequest } from "@services/http";
import { bannersUrl, type Banner } from "./cmdListBanners";

export class CommandTurnOffBanner {
  async run(uuid: string): Promise<Banner> {
    try {
      return await httpRequest<Banner>(`${bannersUrl()}${uuid}/turn-off/`, { method: "POST" });
    } catch (error) {
      console.error("Error turning off banner:", error);
      throw error;
    }
  }
}
